module.exports = __webpack_public_path__ + "img/img_2@2x.f8eddba3.png";